const alert = [
  { text: 'Alert Only', value: '0' },
  { text: 'Execute', value: '1' },
  { text: 'Execute & Alert', value: '2' },
];

module.exports = { alert };
